module["exports"] = [
  "se",
  "nu",
  "info",
  "com",
  "org"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sv/internet/domain_suffix.js
// module id = 1613
// module chunks = 0